import React from "react";
import Vars from "../../config/vars";
const ThreeQuarter = (props) => (
  <div
    className={"threeQ " + props.className}
    style={{
      backgroundColor: props.bgc,
      color: props.color,
      fontSize: props.fontSize,
      textAlign: props.textAlign,
      ...props.styles,
    }}
  >
    {props.children}
  </div>
);

ThreeQuarter.defaultProps = {
  color: "#444",
  bgc: "transparent",
  fontSize: "16px",
  textAlign: "initial",
  styles: {
    padding:
      window.innerWidth > 899
        ? "0 " + Vars.gutter + " 24px " + Vars.gutter
        : window.innerWidth < 600
        ? "0"
        : Vars.gutter,
    lineHeight: "19px",
    maxWidth: "900px",
    width: window.innerWidth > 899 ? "75%" : "100%",
    border: "0px dashed #cc00cc",
    display: "inline-block",
    float: "left",
  },
  children: "woot",
};

export default ThreeQuarter;
